import { render } from "./RoleInput.vue?vue&type=template&id=7f18e0a4"
import script from "./RoleInput.vue?vue&type=script&lang=js"
export * from "./RoleInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/app/app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__